var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pdf-ptn",attrs:{"id":"fund-transactions-download-pdf-button","href":"#/"},on:{"click":function($event){return _vm.downloadTransaction(_vm.params.data.id)}}},[_vm._v("Download PDF")])}
var staticRenderFns = []

export { render, staticRenderFns }